/** Token from Google Search Console (HTML tag method). */
const GOOGLE_SITE_VERIFICATION = 'd0O5XOQDYnADuS-RgWlgSu-aN-YHy5MzI_TgY2IeYLk';

/**
 * Ensures <meta name="google-site-verification" content="..."> exists.
 * Domain properties still require a DNS TXT record at the registrar — see index.html comment.
 */
export function ensureGoogleSiteVerificationMeta(): void {
  if (typeof document === 'undefined') return;
  let el = document.querySelector('meta[name="google-site-verification"]') as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', 'google-site-verification');
    document.head.insertAdjacentElement('afterbegin', el);
  }
  el.setAttribute('content', GOOGLE_SITE_VERIFICATION);
}
